// src/hooks/useSpeechToText.ts
import { useEffect, useRef, useState } from "react";

export function useSpeechToText(initialLang: string = "en-US") {
  const [listening, setListening] = useState(false);
  const [supported] = useState(
    !!(window as any).webkitSpeechRecognition || !!(window as any).SpeechRecognition
  );
  const [lang, setLang] = useState(initialLang);
  const recRef = useRef<any>(null);

  function ensure() {
    const W = window as any;
    const SR = W.SpeechRecognition || W.webkitSpeechRecognition;
    if (!SR) return null;
    if (!recRef.current) {
      recRef.current = new SR();
      recRef.current.interimResults = true;
      recRef.current.continuous = false; // one utterance
    }
    recRef.current.lang = lang;          // <-- keep recognition language in sync
    return recRef.current;
  }

  function start(onFinal: (text: string) => void, onPartial?: (text: string) => void) {
    const rec = ensure();
    if (!rec) return;

    rec.onresult = (e: any) => {
      let interim = "";
      let final = "";
      for (let i = e.resultIndex; i < e.results.length; i++) {
        const t = e.results[i][0].transcript;
        if (e.results[i].isFinal) final += t;
        else interim += t;
      }
      if (interim && onPartial) onPartial(interim);
      if (final) onFinal(final.trim());
    };

    rec.onspeechend = () => {
      try { rec.stop(); } catch {}
    };

    rec.onend = () => setListening(false);
    rec.onerror = () => setListening(false);

    setListening(true);
    rec.start();
  }

  function stop() {
    const rec = recRef.current;
    if (rec && listening) {
      try { rec.stop(); } catch {}
    }
  }

  return { supported, listening, start, stop, lang, setLang };
}
